(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[342],{

/***/ 6628:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/news",
      function () {
        return __webpack_require__(8985);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2657);
/* harmony import */ var _PostItem_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4349);
/* harmony import */ var _PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3__);






function PostItem(param) {
    var image = param.image, title = param.title, brand = param.brand, publication = param.publication, lightUi = param.lightUi, className = param.className;
    if (!image) return null;
    var setTag = publication ? publication : brand;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().container), className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().light), lightUi === true)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().imgWrap),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().img),
                    images: [
                        {
                            url: image,
                            params: "w_240,f_auto"
                        },
                        {
                            url: image,
                            params: "w_350,f_auto"
                        }, 
                    ]
                })
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().title),
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            setTag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_PostItem_module_css__WEBPACK_IMPORTED_MODULE_3___default().tag),
                dangerouslySetInnerHTML: {
                    __html: setTag
                }
            })
        ]
    });
}
PostItem.propTypes = {
    image: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    brand: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    publication: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    lightUi: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
PostItem.defaultProps = {
    image: "",
    title: "",
    brand: "",
    publication: "",
    lightUi: false,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (PostItem);


/***/ }),

/***/ 8985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ news; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Layout/index.js + 1 modules
var Layout = __webpack_require__(3825);
// EXTERNAL MODULE: ./components/WordpressSEO/index.js
var WordpressSEO = __webpack_require__(1610);
// EXTERNAL MODULE: ./components/NewsHeader/index.js
var NewsHeader = __webpack_require__(9753);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ArticleItem/index.js
var ArticleItem = __webpack_require__(9980);
// EXTERNAL MODULE: ./components/BlocksNews/ArticleGridBlock/ArticleGridBlock.module.css
var ArticleGridBlock_module = __webpack_require__(9493);
var ArticleGridBlock_module_default = /*#__PURE__*/__webpack_require__.n(ArticleGridBlock_module);
;// CONCATENATED MODULE: ./components/BlocksNews/ArticleGridBlock/index.js








function ArticleGridBlock(param) {
    var layout = param.layout, featureSource = param.featureSource, featureArticle = param.featureArticle, featureArticleLatest = param.featureArticleLatest, gridSource = param.gridSource, gridArticles = param.gridArticles, gridArticlesLatest = param.gridArticlesLatest;
    var renderArticle = function(p) {
        var ref, ref1;
        var imgDetails = (ref = p.acfPost) === null || ref === void 0 ? void 0 : (ref1 = ref.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.mediaDetails;
        var isLandscapeImage = (imgDetails === null || imgDetails === void 0 ? void 0 : imgDetails.width) > (imgDetails === null || imgDetails === void 0 ? void 0 : imgDetails.height);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
            className: classnames_default()((ArticleGridBlock_module_default()).article, (0,_define_property/* default */.Z)({}, (ArticleGridBlock_module_default()).articleLandscape, isLandscapeImage)),
            landscapeImg: isLandscapeImage
        }), p.slug);
    };
    var renderFeature = function() {
        var article = featureSource === "latest" ? featureArticleLatest[0] : featureArticle[0];
        if (!article || article.length < 1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItem/* default */.Z, (0,_object_spread/* default */.Z)({
            className: (ArticleGridBlock_module_default()).feature,
            feature: true
        }, article));
    };
    var renderGrid = function() {
        var articles = gridSource === "latest" ? gridArticlesLatest : gridArticles;
        if (!articles || articles.length < 1) return null;
        return articles.map(function(p) {
            return renderArticle(p);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ArticleGridBlock_module_default()).container, (0,_define_property/* default */.Z)({}, (ArticleGridBlock_module_default()).containerReversed, layout !== "left")),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleGridBlock_module_default()).feature,
                children: renderFeature()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleGridBlock_module_default()).grid,
                children: renderGrid()
            })
        ]
    });
}
ArticleGridBlock.propTypes = {
    layout: (prop_types_default()).string,
    featureSource: (prop_types_default()).string,
    featureArticle: (prop_types_default()).array,
    featureArticleLatest: (prop_types_default()).array,
    gridSource: (prop_types_default()).string,
    gridArticles: (prop_types_default()).array,
    gridArticlesLatest: (prop_types_default()).array
};
ArticleGridBlock.defaultProps = {
    layout: "",
    featureSource: "",
    featureArticle: [],
    featureArticleLatest: [],
    gridSource: "",
    gridArticles: [],
    gridArticlesLatest: []
};
/* harmony default export */ var BlocksNews_ArticleGridBlock = (ArticleGridBlock);

// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(698);
// EXTERNAL MODULE: ./components/CloudinaryMedia/index.js + 3 modules
var CloudinaryMedia = __webpack_require__(2657);
// EXTERNAL MODULE: ./components/Link/index.js + 1 modules
var Link = __webpack_require__(5641);
// EXTERNAL MODULE: ./components/CoverHighlight/CoverHighlight.module.css
var CoverHighlight_module = __webpack_require__(6677);
var CoverHighlight_module_default = /*#__PURE__*/__webpack_require__.n(CoverHighlight_module);
;// CONCATENATED MODULE: ./components/CoverHighlight/index.js







// TODO: This is similar to <SliderCover /> so we could try and refactor both
// to combine. Just need to consider how data is passed into each component and unify.
function CoverHighlight(param) {
    var cover = param.cover, className = param.className;
    var windowSize = (0,useWindowSize/* default */.Z)();
    var isDesktop = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900;
    var isMobile = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 900;
    var slug = cover.slug, title = cover.title, acfHighlightCover = cover.acfHighlightCover, acfHighlightSettings = cover.acfHighlightSettings, acfBlocks = cover.acfBlocks;
    if (!acfHighlightCover.covers) return null;
    var ref = acfHighlightCover.covers[0], videoMobile = ref.videoMobile, videoMobileWebm = ref.videoMobileWebm, videoDesktop = ref.videoDesktop, videoDesktopWebm = ref.videoDesktopWebm, imageMobile = ref.imageMobile, imageDesktop = ref.imageDesktop;
    // TODO: Added quickly for Cloudinary replacement. Refactor when time allocated.
    // Please put WebMs first in the array.
    var videosMobile = [
        (videoMobileWebm === null || videoMobileWebm === void 0 ? void 0 : videoMobileWebm.mediaItemUrl) ? {
            url: videoMobileWebm.mediaItemUrl,
            type: videoMobileWebm.mimeType
        } : undefined,
        (videoMobile === null || videoMobile === void 0 ? void 0 : videoMobile.mediaItemUrl) ? {
            url: videoMobile.mediaItemUrl,
            type: videoMobile.mimeType
        } : undefined, 
    ].filter(function(x) {
        return x !== undefined;
    });
    var videosDesktop = [
        (videoDesktopWebm === null || videoDesktopWebm === void 0 ? void 0 : videoDesktopWebm.mediaItemUrl) ? {
            url: videoDesktopWebm.mediaItemUrl,
            type: videoDesktopWebm.mimeType
        } : undefined,
        (videoDesktop === null || videoDesktop === void 0 ? void 0 : videoDesktop.mediaItemUrl) ? {
            url: videoDesktop.mediaItemUrl,
            type: videoDesktop.mimeType
        } : undefined, 
    ].filter(function(x) {
        return x !== undefined;
    });
    //
    var images = [
        (imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.mediaItemUrl) ? {
            url: imageMobile.mediaItemUrl,
            params: "f_auto"
        } : undefined,
        (imageDesktop === null || imageDesktop === void 0 ? void 0 : imageDesktop.mediaItemUrl) ? {
            url: imageDesktop.mediaItemUrl,
            params: "f_auto"
        } : undefined, 
    ].filter(function(x) {
        return x !== undefined;
    });
    var model = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : acfHighlightSettings.models;
    var setLink = function(label, className) {
        return (acfBlocks === null || acfBlocks === void 0 ? void 0 : acfBlocks.contentBlocks.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            className: className,
            href: slug,
            type: "Highlight",
            children: label
        }) : label;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CoverHighlight_module_default()).container, className),
        children: [
            (videosMobile || images) && isMobile && setLink(/*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                videos: videosMobile,
                videoLoop: true,
                images: images
            })),
            (videosDesktop || images) && isDesktop && setLink(/*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia/* default */.Z, {
                videos: videosDesktop,
                videoLoop: true,
                images: images
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CoverHighlight_module_default()).infoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CoverHighlight_module_default()).info,
                    children: [
                        (model === null || model === void 0 ? void 0 : model.slug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: model.slug,
                            type: "Model",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (CoverHighlight_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: model.title
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (CoverHighlight_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        (acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription) && setLink(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CoverHighlight_module_default()).tag,
                                dangerouslySetInnerHTML: {
                                    __html: acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription
                                }
                            })
                        }), (CoverHighlight_module_default()).tags),
                        (acfBlocks === null || acfBlocks === void 0 ? void 0 : acfBlocks.contentBlocks.length) > 0 && setLink("View Article", (CoverHighlight_module_default()).link)
                    ]
                })
            })
        ]
    });
}
CoverHighlight.propTypes = {
    cover: (prop_types_default()).object,
    className: (prop_types_default()).string
};
CoverHighlight.defaultProps = {
    cover: {},
    className: ""
};
/* harmony default export */ var components_CoverHighlight = (CoverHighlight);

;// CONCATENATED MODULE: ./components/BlocksNews/HighlightBlock/index.js



function HighlightBlock(param) {
    var highlight = param.highlight;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CoverHighlight, {
        cover: highlight
    });
}
HighlightBlock.propTypes = {
    highlight: (prop_types_default()).object
};
HighlightBlock.defaultProps = {
    highlight: {}
};
/* harmony default export */ var BlocksNews_HighlightBlock = (HighlightBlock);

// EXTERNAL MODULE: ./components/Title/index.js
var Title = __webpack_require__(1382);
// EXTERNAL MODULE: ./components/PostItem/index.js
var PostItem = __webpack_require__(7402);
// EXTERNAL MODULE: ./components/BlocksNews/ShowcaseBlock/ShowcaseBlock.module.css
var ShowcaseBlock_module = __webpack_require__(9020);
var ShowcaseBlock_module_default = /*#__PURE__*/__webpack_require__.n(ShowcaseBlock_module);
;// CONCATENATED MODULE: ./components/BlocksNews/ShowcaseBlock/index.js







function ShowcaseBlock(param) {
    var showcase = param.showcase, className = param.className;
    if (!showcase) return null;
    var _acfShowcases = showcase.// TODO: No longer needed in graphql
    // acfShowcaseSettings: { boardLink },
    acfShowcases, showcaseTitle = _acfShowcases.showcaseTitle, link = _acfShowcases.link, subtitle = _acfShowcases.subtitle, showcasesGrid = _acfShowcases.showcasesGrid;
    var setTitle = showcaseTitle ? showcaseTitle.split("\n") : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ShowcaseBlock_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ShowcaseBlock_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ShowcaseBlock_module_default()).header,
                    children: [
                        setTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                            title: setTitle[0],
                            subtitle: setTitle[1] || null,
                            borderTitle: true,
                            lightSubtitle: true
                        }),
                        link && subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            className: (ShowcaseBlock_module_default()).link,
                            href: link.slug,
                            type: link.__typename,
                            children: subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ShowcaseBlock_module_default()).showcases,
                    children: showcasesGrid === null || showcasesGrid === void 0 ? void 0 : showcasesGrid.map(function(param) {
                        var image = param.image, model = param.model, brand = param.brand, publication = param.publication;
                        var ref, ref1;
                        if (!(model === null || model === void 0 ? void 0 : model.slug)) return null;
                        var slug = model.slug;
                        var title = model.title;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            className: (ShowcaseBlock_module_default()).showcase,
                            href: slug,
                            type: "Model",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem/* default */.Z, {
                                image: image === null || image === void 0 ? void 0 : image.mediaItemUrl,
                                title: title,
                                brand: brand === null || brand === void 0 ? void 0 : (ref = brand[0]) === null || ref === void 0 ? void 0 : ref.name,
                                publication: publication === null || publication === void 0 ? void 0 : (ref1 = publication[0]) === null || ref1 === void 0 ? void 0 : ref1.name,
                                lightUi: true
                            })
                        }, slug);
                    })
                })
            ]
        })
    });
}
ShowcaseBlock.propTypes = {
    showcase: (prop_types_default()).object,
    className: (prop_types_default()).string
};
ShowcaseBlock.defaultProps = {
    showcase: {},
    className: ""
};
/* harmony default export */ var BlocksNews_ShowcaseBlock = (ShowcaseBlock);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/BlocksNews/index.js









function BlocksNews(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    if ((children === null || children === void 0 ? void 0 : children.length) < 1) return null;
    var articleGridBlock = "Page_Acfnews_Blocks_ArticleGrid";
    var highlightBlock = "Page_Acfnews_Blocks_Highlight";
    var showcaseBlock = "Page_Acfnews_Blocks_Showcase";
    var blockType = function(block) {
        switch(block.__typename){
            case articleGridBlock:
                return {
                    block: "articleGrid",
                    component: BlocksNews_ArticleGridBlock
                };
            case highlightBlock:
                return {
                    block: "highlight",
                    component: BlocksNews_HighlightBlock
                };
            case showcaseBlock:
                return {
                    block: "showcase",
                    component: BlocksNews_ShowcaseBlock
                };
            default:
                return null;
        }
    };
    return children.map(function(child, i) {
        // console.log('child: ', child)
        if (!child) return null;
        var getBlockType = blockType(child);
        if (!getBlockType) return null;
        var articleGrid = getBlockType.block === "articleGrid";
        var component = /*#__PURE__*/ react.createElement(getBlockType.component, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child), {
            key: i
        }), rest));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(getBlockType.block, "Block\n        "),
            children: component
        }, i);
    });
}
BlocksNews.propTypes = {
    children: (prop_types_default()).array,
    rest: (prop_types_default()).object
};
BlocksNews.defaultProps = {
    children: [],
    rest: {}
};
/* harmony default export */ var components_BlocksNews = (BlocksNews);

// EXTERNAL MODULE: ./components/ArticleGrid/index.js
var ArticleGrid = __webpack_require__(6253);
// EXTERNAL MODULE: ./components/Pagination/index.js
var Pagination = __webpack_require__(919);
// EXTERNAL MODULE: ./pages/[site]/news/news.module.css
var news_module = __webpack_require__(8686);
var news_module_default = /*#__PURE__*/__webpack_require__.n(news_module);
;// CONCATENATED MODULE: ./pages/[site]/news/index.js









function News(param) {
    var title = param.title, acfNews = param.acfNews, firstFeaturePost = param.firstFeaturePost, seo = param.seo, globalSettings = param.globalSettings, categorySlug = param.categorySlug, site = param.site, posts = param.posts, offsetPagination = param.offsetPagination;
    var ref, ref1, ref2, ref3;
    if (!acfNews) return null;
    var categoriesMenu = acfNews.categoriesMenu, blocks = acfNews.blocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                url: "/".concat(site, "/news"),
                title: title,
                seo: seo,
                image: firstFeaturePost === null || firstFeaturePost === void 0 ? void 0 : (ref = firstFeaturePost.nodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.acfPost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.sourceUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsHeader/* default */.Z, {
                categorySlug: categorySlug,
                categories: categoriesMenu
            }),
            blocks && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlocksNews, {
                children: blocks
            }),
            (posts === null || posts === void 0 ? void 0 : posts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleGrid/* default */.Z, {
                className: (news_module_default()).morePosts,
                articleClassName: (news_module_default()).morePost,
                articles: posts
            }),
            offsetPagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                pagination: offsetPagination,
                currentPage: 1
            })
        ]
    });
}
News.propTypes = {
    seo: (prop_types_default()).object,
    globalSettings: (prop_types_default()).object,
    categorySlug: (prop_types_default()).string
};
News.defaultProps = {
    seo: {},
    globalSettings: {},
    categorySlug: ""
};
var __N_SSG = true;
/* harmony default export */ var news = (News);


/***/ }),

/***/ 9493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticleGridBlock_spacing--xxxs__9Hihg","spacing--xxs":"ArticleGridBlock_spacing--xxs__jQO41","spacing--xs":"ArticleGridBlock_spacing--xs__XYB07","spacing--sm":"ArticleGridBlock_spacing--sm__DHKLs","spacing--md":"ArticleGridBlock_spacing--md__v_Gh6","spacing--lg":"ArticleGridBlock_spacing--lg___Fvmw","spacing--xl":"ArticleGridBlock_spacing--xl__LNTUx","spacing--xxl":"ArticleGridBlock_spacing--xxl__A8Ekb","spacing--xxxl":"ArticleGridBlock_spacing--xxxl__nppQp","container":"ArticleGridBlock_container__LEjIw","containerReversed":"ArticleGridBlock_containerReversed__EMF2A","feature":"ArticleGridBlock_feature__kShad","grid":"ArticleGridBlock_grid__JMUdX","articleLandscape":"ArticleGridBlock_articleLandscape__mZdaa","article":"ArticleGridBlock_article__8SGTr","fadeInItems":"ArticleGridBlock_fadeInItems__ZfSAb"};

/***/ }),

/***/ 9020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ShowcaseBlock_spacing--xxxs__p_oQP","spacing--xxs":"ShowcaseBlock_spacing--xxs__6YHpx","spacing--xs":"ShowcaseBlock_spacing--xs__Ealzq","spacing--sm":"ShowcaseBlock_spacing--sm__wLkAt","spacing--md":"ShowcaseBlock_spacing--md___94jM","spacing--lg":"ShowcaseBlock_spacing--lg__ASBdd","spacing--xl":"ShowcaseBlock_spacing--xl__8bZcQ","spacing--xxl":"ShowcaseBlock_spacing--xxl__kW8GP","spacing--xxxl":"ShowcaseBlock_spacing--xxxl__xcBZX","container":"ShowcaseBlock_container__ki5_H","wrapper":"ShowcaseBlock_wrapper__LDTYN","header":"ShowcaseBlock_header__Xsko7","link":"ShowcaseBlock_link__IQXb8","showcases":"ShowcaseBlock_showcases__gmzD1","showcase":"ShowcaseBlock_showcase__gTUMp","fadeInItems":"ShowcaseBlock_fadeInItems__SgFKm"};

/***/ }),

/***/ 6677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CoverHighlight_spacing--xxxs__v3tke","spacing--xxs":"CoverHighlight_spacing--xxs__FB_G0","spacing--xs":"CoverHighlight_spacing--xs__HUYH6","spacing--sm":"CoverHighlight_spacing--sm__Inv4O","spacing--md":"CoverHighlight_spacing--md__nitr7","spacing--lg":"CoverHighlight_spacing--lg__tIz_K","spacing--xl":"CoverHighlight_spacing--xl__zB5OO","spacing--xxl":"CoverHighlight_spacing--xxl__DE5Lc","spacing--xxxl":"CoverHighlight_spacing--xxxl__P61Eb","container":"CoverHighlight_container__MmV3g","infoWrapper":"CoverHighlight_infoWrapper__h48rN","info":"CoverHighlight_info__yEQu_","title":"CoverHighlight_title__wtbGx","tag":"CoverHighlight_tag__lfZ_G","link":"CoverHighlight_link__osxbH","tags":"CoverHighlight_tags__yzDH5","fadeInItems":"CoverHighlight_fadeInItems__MkfVU"};

/***/ }),

/***/ 4349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"PostItem_spacing--xxxs___RSJI","spacing--xxs":"PostItem_spacing--xxs__W7YLA","spacing--xs":"PostItem_spacing--xs__coAYB","spacing--sm":"PostItem_spacing--sm__eMzuo","spacing--md":"PostItem_spacing--md__PlY_p","spacing--lg":"PostItem_spacing--lg__zuGtl","spacing--xl":"PostItem_spacing--xl__q_EaG","spacing--xxl":"PostItem_spacing--xxl__gGqTC","spacing--xxxl":"PostItem_spacing--xxxl__YoF39","container":"PostItem_container__IPVxO","light":"PostItem_light__OcpKj","title":"PostItem_title__UYJ6m","tag":"PostItem_tag__cJ1yi","imgWrap":"PostItem_imgWrap__K3bpc","img":"PostItem_img__AD8wr","fadeInItems":"PostItem_fadeInItems__kdjFV"};

/***/ }),

/***/ 8686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"news_spacing--xxxs__BDhDn","spacing--xxs":"news_spacing--xxs__zFdlo","spacing--xs":"news_spacing--xs__8Ocj_","spacing--sm":"news_spacing--sm__zX_0t","spacing--md":"news_spacing--md__Pij3J","spacing--lg":"news_spacing--lg__zYb5f","spacing--xl":"news_spacing--xl__aHYx5","spacing--xxl":"news_spacing--xxl__715kW","spacing--xxxl":"news_spacing--xxxl__KyvId","morePosts":"news_morePosts__s4jLG","morePost":"news_morePost__mRNzg","fadeInItems":"news_fadeInItems__JWHvi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,462,774,888,179], function() { return __webpack_exec__(6628); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);